import {
    ILoyaltyCertType,
    ILoyaltyCertTypeListItem,
} from '@/entity/loyalty/loyaltyCert/loyaltyCertType/LoyaltyCertType.types';
import Vue from 'vue';
import Component from 'vue-class-component';
import { LoyaltyCertTypeStore } from '@/store/modules/Loyalty/Cert/LoyaltyCertType';

@Component
export class LoyaltyCertTypesMix extends Vue {
    get loyaltyCertTypes(): ILoyaltyCertType | null {
        return LoyaltyCertTypeStore.loyaltyCertTypes;
    }
    get loyaltyCertTypeItem(): ILoyaltyCertTypeListItem | null {
        return LoyaltyCertTypeStore.loyaltyCertType;
    }
    get itemsLoaded(): boolean {
      return LoyaltyCertTypeStore.loyaltyCertTypeLoaded;
    }
}
